import { Component, OnInit, Input } from '@angular/core';


@Component({
  selector: 'app-svg',
  templateUrl: './svg.component.html',
	styleUrls: ['./svg.component.scss'],
	host: {
		class: 'app-svg'
	}
})
export class SVGComponent implements OnInit {
  @Input() svg: string;
  @Input() classes: string = '';
  @Input() alt: string = '';
  @Input() size: string = ''; // xs, s, m, l, xl

  constructor() { }

  ngOnInit() {

  }

}
